<div class="card card-nb rounded-4">
    <div class="card-body pb-0 rounded-4">
        <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
                <div class="d-flex align-items-center">
                    <img src="{{integrationApp.slimIntegrationApp.iconUrl}}" alt="Integration App Icon"
                        style="max-width: 100px; height: auto; border-radius: 10px;">
                </div>
                <div class="d-flex flex-row justify-content-between flex-grow-1 ml-3">
                    <div class="d-flex flex-column">
                        <span class="font-weight-bold">{{integrationApp.slimIntegrationApp.name}}&nbsp;</span>
                        <span class="subinformations"
                            [innerHTML]="'integration-apps-card-long_display_vendor' | i18next: { vendor: integrationApp.slimIntegrationApp.vendor }"></span>
                    </div>
                    <button class="btn btn-outline-primary"
                        [routerLink]="['/integration-apps/details', integrationApp.slimIntegrationApp.uuid]">{{'app_details'
                        | i18next}}</button>
                </div>
            </div>
            <div class="d-flex flex-row">
                <div class="d-flex flex-column mr-1 flex-grow-1 indent-left">
                    <hr class="mt-2 mb-2">
                    <div class="d-flex flex-row flex-wrap mb-2 align-items-center">
                        <span class="subinformations mr-3">{{'label_installations' | i18next}} ({{
                            integrationApp.appliances.length }})</span>
                        @if (integrationApp.appliances.length <= 5) { 
                            @for (appliance of integrationApp.appliances; track appliance.id) { 
                                <p-chip class="subinformations mr-2 mt-1 mb-1 pt-1 pb-1 flex-shrink-0" style="background-color: #dadada; font-size: small; white-space: nowrap;" label="[{{appliance.id}}] {{appliance.name}}" />
                            }
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>